<template>
  <div class="_60_w px-3 py-5">
    <v-row no-gutters>
      <v-col cols="12" md="12">
        <div class="pa-2">
          <p class="default_txt">Full Name</p>
          <v-text-field
            :disabled="
              permissions.includes('UPCM') ||
              role == 'VENDOR' ||
              role == 'SUPERADMIN'
                ? false
                : true
            "
            dense
            v-model="person.name"
            placeholder="Type Here"
            hide-details
            color="green"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <div class="pa-2">
          <p class="default_txt">NIK</p>
          <v-text-field
            :disabled="
              permissions.includes('UPCM') ||
              role == 'VENDOR' ||
              role == 'SUPERADMIN'
                ? false
                : true
            "
            v-model="person.nik"
            dense
            placeholder="Type Here"
            hide-details
            color="green"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <div class="pa-2">
          <p class="default_txt">Gender</p>
          <v-radio-group
            :disabled="
              permissions.includes('UPCM') ||
              role == 'VENDOR' ||
              role == 'SUPERADMIN'
                ? false
                : true
            "
            v-model="person.gender"
            hide-details
            class="ma-0"
            dense
            row
          >
            <v-radio
              label="Male"
              color="green"
              value="Male"
            ></v-radio>
            <v-radio
              label="Female"
              color="green"
              value="Female"
            ></v-radio>
          </v-radio-group>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="pa-2">
          <p class="default_txt">Email</p>
          <v-text-field
            :disabled="
              permissions.includes('UPCM') ||
              role == 'VENDOR' ||
              role == 'SUPERADMIN'
                ? false
                : true
            "
            v-model="person.email"
            dense
            placeholder="Type Here"
            hide-details
            color="green"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="pa-2">
          <p class="default_txt">Username</p>
          <v-text-field
            :disabled="
              permissions.includes('UPCM') ||
              role == 'VENDOR' ||
              role == 'SUPERADMIN'
                ? false
                : true
            "
            v-model="person.username"
            dense
            placeholder="Type Here"
            hide-details
            color="green"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <div
      class="d-flex justify-end mt-2"
      v-if="
        permissions.includes('UPCM') || role == 'VENDOR' || role == 'SUPERADMIN'
      "
    >
      <v-btn
        class="bg_default text-capitalize rounded-lg"
        @click="updateData"
        depressed
        dark
        >Save</v-btn
      >
    </div>
    <v-overlay :absolute="true" color="white" opacity=".5" :value="loading">
      <v-progress-circular
        indeterminate
        class="mr-2"
        color="#006341"
      ></v-progress-circular>
      <b class="color_default">Loading...</b>
    </v-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "updateTf",
  props: ["person"],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  mounted() {},
  methods: {
    updateData() {
      this.loading = true;
      let body = {
        id: this.person.user_id,
        username: this.person.username,
        name: this.person.name,
        email: this.person.email,
        nik: this.person.nik,
        gender: this.person.gender,
      };
      let data = {
        path: "manage/vendor_user/update",
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.loading = false;
        })
        .catch((e) => {
          if (e.data) {
            var key = Object.keys(e.data.errors);
            var values = Object.values(e.data.errors);
            for (let i = 0; i < key.length; i++) {
              for (let j = 0; j < values[i].length; j++) {
                this.$toast.error(values[i][j]);
              }
            }
          } else {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
